module.exports = __webpack_public_path__ + "static/img/CgoRC2RCULuAX735AASL3Lar_4o777.cd37ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2RCULuAX735AASL3Lar_4o777.png
// module id = dAs6
// module chunks = 73